import './index.css'

export const NavBar = () => {
  return (
    <div className="header-wrapper">
      <div className="header">
        <a
          className="header-button"
          href="https://commencement.mit.edu/index.php/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <img
            src={'/images/MIT-Icon.png'}
            className="logo"
            alt="MIT logo"
            width={51}
            height={27}
          />
          <p className="text-style">Commencement</p>
        </a>
      </div>
    </div>
  )
}
